import Post from './containers/Post';
import { IPostRenderProps } from './types';

export { Post, IPostRenderProps };
